import React from 'react';
import PropTypes from 'prop-types';

const ShareButton = ({ children, color }) => (
  <button
    className="fe-share-btn"
    style={{ backgroundColor: color }}
  >
    { children }
  </button>
);

ShareButton.propTypes = {
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]),
};

export default ShareButton;